<template>
    <div>
        slide
    </div>
</template>

<script>
import ctrl from "./multiProduct.js";
export default ctrl;
</script>